export enum Teilimpfungsart {
    Einfachimpfung = 0,
    Teilimpfung1 = 1,
    Teilimpfung2 = 2,
    Teilimpfung3 = 3,
    Teilimpfung4 = 4,
    Auffrischung = 9,
    AuffrischungsSerieTeil1 = 10,
    AuffrischungsSerieTeil2 = 11,
}
